export default (node) => {
  const variantSelectButtons = node.querySelectorAll(
    '[data-variant-select-button]'
  );

  const selectedVariantText = node.querySelector('[data-selected-variant]');

  /**
   * Functions
   */
  const changeSelectedVariant = (button) => {
    const { variant, variantTitle, available, price, compareAtPrice, selectedColor, selectedSize } =
      button.dataset;

    document
      .querySelector('[data-product-carousel-variant="' + variant + '"]')
      ?.click();

    updateSelectedVariantText(variantTitle);

    // Remove active class from all buttons
    variantSelectButtons.forEach((button) => {
      button.classList.remove('color-select--active');
    });
    // Add active class to the clicked button
    button.classList.add('color-select--active');

    // Dispatch event to scroll to the selected image and update the carousel
    const event = new CustomEvent('product-image:scroll-to-image', {
      detail: { scroll },
    });
    document.dispatchEvent(event);

    // Update add to cart button
    const eventUpdateButton = new CustomEvent(
      'add-to-cart:selected-variant-change',
      {
        detail: {
          variantId: variant,
          availability: available,
          price,
          compareAtPrice,
          selectedColor,
          selectedSize,
        },
      }
    );
    document.dispatchEvent(eventUpdateButton);

    // emit event for change in variant
    document.dispatchEvent(
      new CustomEvent('variant:changed', {
        detail: {
          variantId: variant,
        },
      })
    );

    // Update pair it with button
    document.dispatchEvent(new CustomEvent('pair-it-with:update-content'));
  };

  const updateSelectedVariantText = (variantTitle) => {
    selectedVariantText.innerHTML = variantTitle;
  };

  const init = () => {
    variantSelectButtons.forEach((button) => {
      button.addEventListener('click', () => changeSelectedVariant(button));
    });
  };

  /**
   * Init
   */
  init();
};
